
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebb5a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebb5a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bEHle", function(module, exports) {
module.exports = import("2uln8").then(()=>parcelRequire('l3ZHh'));

});

// Analytics for the marketing page.
//
// Same Mixpanel project as the app, and deliberately the same SDK: the landing
// sits on vibetoon.com/ and the app on vibetoon.com/app, so localStorage is
// shared and the anonymous distinct_id carries straight over into the builder.
// Hand-rolling the id format here would break that stitching.
//
// The token is a browser-side public key, same as the Stripe publishable key —
// but it must differ per environment, otherwise staging would report into the
// production project. Parcel inlines process.env from the .env file on the
// machine that runs the build, so each server carries its own value.
const $a9032ec354beaac7$var$TOKEN = "4dc589f39d8b60ce9ab318bac2d10fcb";
const $a9032ec354beaac7$var$API_HOST = 'https://api-eu.mixpanel.com';
// Campaign attribution. The landing page is the first stop from an ad, so it is
// the one that captures the tag. Storage is shared with the app (same domain);
// key and format match frontend/src/analytics.ts.
var $a9032ec354beaac7$var$ATTRIBUTION_KEY = 'vt_attribution';
var $a9032ec354beaac7$var$ATTRIBUTION_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content'
];
function $a9032ec354beaac7$var$readAttribution() {
    try {
        var stored = localStorage.getItem($a9032ec354beaac7$var$ATTRIBUTION_KEY);
        if (stored) return JSON.parse(stored);
        var query = new URLSearchParams(window.location.search);
        var fresh = {};
        $a9032ec354beaac7$var$ATTRIBUTION_PARAMS.forEach(function(key) {
            var value = query.get(key);
            if (value) fresh[key] = value.slice(0, 100);
        });
        if (!Object.keys(fresh).length) return {};
        fresh.first_seen_at = new Date().toISOString();
        localStorage.setItem($a9032ec354beaac7$var$ATTRIBUTION_KEY, JSON.stringify(fresh));
        return fresh;
    } catch (e) {
        return {};
    }
}
var $a9032ec354beaac7$var$attribution = $a9032ec354beaac7$var$readAttribution();
let $a9032ec354beaac7$var$client = null;
let $a9032ec354beaac7$var$loading = null;
const $a9032ec354beaac7$var$pending = [];

function $a9032ec354beaac7$var$load() {
    if ($a9032ec354beaac7$var$loading) return $a9032ec354beaac7$var$loading;
    $a9032ec354beaac7$var$loading = (parcelRequire("bEHle")).then((mod)=>{
        const instance = mod.default || mod;
        instance.init($a9032ec354beaac7$var$TOKEN, {
            api_host: $a9032ec354beaac7$var$API_HOST,
            persistence: 'localStorage',
            autocapture: false,
            ignore_dnt: false,
            record_sessions_percent: 0
        });
        $a9032ec354beaac7$var$client = instance;
        $a9032ec354beaac7$var$pending.splice(0).forEach((fn)=>{
            try {
                fn(instance);
            } catch (e) {
            /* analytics must never break the page */ }
        });
    }).catch(()=>{
        $a9032ec354beaac7$var$pending.length = 0;
    });
    return $a9032ec354beaac7$var$loading;
}
function $a9032ec354beaac7$export$6b2a7d5132615086(event, props) {
    if (!$a9032ec354beaac7$var$TOKEN) return;
    props = Object.assign({}, $a9032ec354beaac7$var$attribution, props || {});
    if ($a9032ec354beaac7$var$client) {
        try {
            $a9032ec354beaac7$var$client.track(event, props);
        } catch (e) {
        /* ignore */ }
        return;
    }
    if ($a9032ec354beaac7$var$pending.length < 20) $a9032ec354beaac7$var$pending.push((c)=>c.track(event, props));
    $a9032ec354beaac7$var$load();
}
function $a9032ec354beaac7$export$2cd8252107eb640b() {
    if (!$a9032ec354beaac7$var$TOKEN) return;
    // Warm up when the browser is idle — this is a marketing page, nothing here
    // is allowed to compete with the first paint.
    if (window.requestIdleCallback) window.requestIdleCallback($a9032ec354beaac7$var$load, {
        timeout: 5000
    });
    else window.setTimeout($a9032ec354beaac7$var$load, 2000);
    $a9032ec354beaac7$export$6b2a7d5132615086('landing_viewed');
    // Delegated: every route into the app is a CTA, whatever it looks like.
    document.addEventListener('click', (event)=>{
        const link = event.target.closest && event.target.closest('a[href^="/app"]');
        if (!link) return;
        $a9032ec354beaac7$export$6b2a7d5132615086('cta_clicked', {
            cta: link.dataset.cta || 'unknown',
            href: link.getAttribute('href')
        });
    });
}


var $93fe0ca3e8a620dd$exports = {};
$93fe0ca3e8a620dd$exports = import.meta.resolve("7yeQP");


navigator.serviceWorker.register($93fe0ca3e8a620dd$exports);
(0, $a9032ec354beaac7$export$2cd8252107eb640b)();


//# sourceMappingURL=landing.ac905426.js.map
